import { FC } from "react";
import { useAppSelector } from "shared/lib/hooks/hooks";
import axios from "axios";
import dayjs from "dayjs";
import { serverURL } from "shared/lib/serverURL";
import calendar from "assets/images/admin/calendar_blue.svg";
import location from "assets/images/admin/location.svg";
import word from "assets/images/marathon/word.svg";
import { useTranslation } from "react-i18next";
import {
  Box,
  Typography,
  Stack,
} from "@mui/material";


const MarathonInfo: FC = () => {
  const marathonInfo = useAppSelector(
    (state) => state.marathon.marathonForAdmin
  );

  const extendedMarathon = useAppSelector((state) => state.marathon.extendedMarathon);

  const { t } = useTranslation();

  const handleDocumentDownload = async (documentUrl: any) => {
    const documentUrlCopy = { ...documentUrl };

    const documentName = documentUrlCopy.document.slice(59);
    const documentExtension =
      documentUrlCopy.document.split(".")[
      documentUrlCopy.document.split(".").length - 1
      ];
    const response = await axios.get(`${serverURL}${documentUrl.document}`, {
      responseType: "blob",
    });
    const href = URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = href;
    link.setAttribute("download", `${documentName}.${documentExtension}`); //or any other extension
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  };


  return (
    <Box sx={{
      paddingTop: "10px"
    }}>
      {marathonInfo && (
        <Box sx={{ width: "100%" }}>
          <Stack spacing={2} mb={4}>
            <Typography
              variant="body2"
              sx={{
                color: "#3e444a",
                fontSize: "18px",
                fontWeight: 600
              }}
            >
              Даты и место проведения
            </Typography>
            <Stack direction="row" spacing={1} alignItems="center">
              <img src={calendar} alt="calendar" />

              <Typography>
                {t("myMarathonsPage.dateOfEvent")} —{" "}
                {dayjs(marathonInfo.date).format("DD.MM.YYYY")}
              </Typography>
            </Stack>

            <Stack direction="row" spacing={1} alignItems="center">
              <img src={calendar} alt="calendar" />

              <Typography>
                {t("viewMarathon.printDate")} —{" "}
                {dayjs(
                  marathonInfo.participantNumbersPrintDate
                ).format("DD.MM.YYYY")}
              </Typography>
            </Stack>

            <Stack direction="row" spacing={1} alignItems="center">
              <img
                src={location}
                alt="location"
                width={20}
                height={20}
                style={{
                  filter:
                    "invert(48%) sepia(84%) saturate(1200%) hue-rotate(180deg) brightness(95%) contrast(90%)",
                }}
              />
              <Typography>
                {t("myMarathonsPage.venue")} — {extendedMarathon?.place}
              </Typography>
            </Stack>
          </Stack>

          <Box mb={5}>
            <Typography variant="h6" mb={2}
              sx={{
                color: "#3e444a",
                fontSize: "18px",
                fontWeight: 600
              }}>
              {t("myMarathon.description")}
            </Typography>

            <Typography
              component="div"
              dangerouslySetInnerHTML={{
                __html: extendedMarathon?.text as string,
              }}
            />
          </Box>

          <Box mb={5}>
            <Typography variant="h6" mb={2}
              sx={{
                color: "#3e444a",
                fontSize: "18px",
                fontWeight: 600
              }}
            >
              {t("myMarathon.documents")}
            </Typography>

            <Stack spacing={3}>
              {marathonInfo.documents.map(
                (document: any, index: number) => (
                  <Box key={index}>
                    <Box
                      onClick={() =>
                        handleDocumentDownload(document)
                      }
                      sx={{
                        width: "100%",
                        maxWidth: 350,
                        border: "1px solid #eee",
                        borderRadius: 2,
                        py: 3,
                        display: "flex",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                    >
                      <img src={word} alt="document" />
                    </Box>

                    <Typography
                      mt={1}
                      sx={{
                        cursor: "pointer",
                        wordBreak: "break-word",
                      }}
                      onClick={() =>
                        handleDocumentDownload(document)
                      }
                    >
                      {document.document.slice(59)}
                    </Typography>
                  </Box>
                )
              )}
            </Stack>
          </Box>

          <Box>
            <Typography variant="h6" mb={2} sx={{
              color: "#3e444a"
            }}>
              {t("myMarathon.partners")}
            </Typography>

            {extendedMarathon?.partners.map(
              (partner: any, index: number) => (
                <Box key={index} mb={4}>
                  <Typography
                    fontWeight={600}
                    mb={2}
                    sx={{
                      color: "#3e444a",
                      fontSize: "14px",
                      fontWeight: 500
                    }}
                  >
                    {partner.name}
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 2,
                    }}
                  >
                    {partner.partnerCompanies.map(
                      (
                        partnerCompany: any,
                        companyIndex: number
                      ) => (
                        <a
                          key={companyIndex}
                          href={partnerCompany.url}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <Box
                            component="img"
                            src={`${serverURL}${partnerCompany.logo}`}
                            alt={partner.name}
                            sx={{
                              width: {
                                xs: 100,
                                sm: 120,
                                md: 130,
                              },
                              height: {
                                xs: 80,
                                sm: 90,
                                md: 100,
                              },
                              borderRadius: 2,
                              border: "4px solid #ECF2F7",
                              objectFit: "contain",
                            }}
                          />
                        </a>
                      )
                    )}
                  </Box>
                </Box>
              )
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default MarathonInfo;
